// Mirrors sk.ladient.amani.enums.AccountingSystem on the backend
export type AccountingSystem =
    | 'POHODA'
    | 'MONEY_S3'
    | 'KROS_OMEGA'
    | 'SUPERFAKTURA'
    | 'KROS_ALFA'
    | 'MRP'
    | 'ISDOC'

export interface AccountingSystemOption {
    value: AccountingSystem
    label: string
    // Format the export is produced in, shown so the user knows what lands in their downloads
    format: string
}

export const accountingSystems: AccountingSystemOption[] = [
    {value: 'POHODA', label: 'POHODA (Stormware)', format: 'XML'},
    {value: 'MONEY_S3', label: 'Money S3 (Seyfor)', format: 'XML'},
    {value: 'KROS_OMEGA', label: 'KROS Omega', format: 'TXT'},
    {value: 'SUPERFAKTURA', label: 'SuperFaktúra', format: 'XML'},
    {value: 'KROS_ALFA', label: 'KROS Alfa plus', format: 'ISDOC'},
    {value: 'MRP', label: 'MRP', format: 'ISDOC'},
    {value: 'ISDOC', label: 'ISDOC', format: 'ISDOC'},
]

export const defaultAccountingSystem: AccountingSystem = 'POHODA'

// Mirrors InvoiceExportFormat on the backend - Omega imports documents only from its own .TXT
const extensions: Record<AccountingSystem, string> = {
    POHODA: 'xml',
    MONEY_S3: 'xml',
    KROS_OMEGA: 'txt',
    SUPERFAKTURA: 'xml',
    KROS_ALFA: 'isdoc',
    MRP: 'isdoc',
    ISDOC: 'isdoc',
}

export function accountingSystemExtension(system: AccountingSystem): string {
    return extensions[system]
}
